import RichText from "./RichText";

const RichTextWithProps = ({ blok }) => {
  return <RichText content={blok.content} theme={blok.theme || "lightGray"} />;
};

export default RichTextWithProps;
